import { CatalogueOfferTooltip } from "./CatalogueOfferTooltip";
import { CatalogueLink } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CatalogueOfferLabel = function CatalogueOfferLabel(_ref) {
  var tooltipTitle = _ref.tooltipTitle,
    catalogueLabel = _ref.catalogueLabel,
    catalogueUrl = _ref.catalogueUrl,
    children = _ref.children,
    offerLabelSmallerOnMobile = _ref.offerLabelSmallerOnMobile;
  if (catalogueLabel && catalogueUrl) {
    return /*#__PURE__*/_jsx(CatalogueOfferTooltip, {
      offerLabelSmallerOnMobile: offerLabelSmallerOnMobile,
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: ["".concat(tooltipTitle, " "), /*#__PURE__*/_jsx(CatalogueLink, {
          href: catalogueUrl,
          children: catalogueLabel
        })]
      }),
      children: children
    });
  }
  return /*#__PURE__*/_jsx(CatalogueOfferTooltip, {
    title: tooltipTitle,
    children: children
  });
};
//# sourceMappingURL=CatalogueOfferLabel.js.map